const useSplashSmsTypes = () => {
  const GET_URL_SMS_SUCCESS = "GET_URL_SMS_SUCCESS";

  return { GET_URL_SMS_SUCCESS };
};

export default useSplashSmsTypes;
